var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ContentSection',{attrs:{"title":"New Blog Post"}},[(_vm.fields)?_c('Form',{ref:"form",attrs:{"fields":_vm.fields}}):_vm._e(),_c('Btn',{on:{"click":_vm.savePost}},[_vm._v("Save")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }